import { QueryOptions } from '@shared/fetch-utils';
import {
  CompetitorMgItemPriceDTO,
  MgItemCardDTO,
  MgItemDocumentationDTO,
  MgItemMarketingDTO,
} from '@retail/products/types';
import { buildUrl } from '@shared/utils';
import { useMPEFetch } from '@retail/app/hooks';
import { mpeApi } from '@retail/mgpris/config';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
interface Props {
  mgItemNumber: number;
}

export function useFetchMgItemCard({ mgItemNumber }: Props, queryOptions?: QueryOptions) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<MgItemCardDTO>({
    method: 'GET',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.mgItems.mgItemNumber.itemCard.core.getFullLinkPath({ mgItemNumber }),
    }),
    token,
    queryKey: ['mg-item-card', mgItemNumber],
    ...queryOptions,
  });
}

export function useFetchSupplierItemsDocumentation(
  { mgItemNumber }: Props,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<MgItemDocumentationDTO>({
    method: 'GET',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.mgItems.mgItemNumber.itemCard.documentation.getFullLinkPath({ mgItemNumber }),
    }),
    token,
    queryKey: ['mg-item-documentation', mgItemNumber],
    ...queryOptions,
  });
}

export function useFetchMgItemMarketing({ mgItemNumber }: Props, queryOptions: QueryOptions = {}) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<MgItemMarketingDTO>({
    method: 'GET',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.mgItems.mgItemNumber.marketing.getFullLinkPath({ mgItemNumber }),
    }),
    token,
    queryKey: ['mg-item-marketing', mgItemNumber],
    ...queryOptions,
  });
}

interface AssortmentCompetitorPricesProps extends QueryOptions {
  mgItemNumber: number;
  assortmentId: number;
}

export function useFetchMgItemAssortmentCompetitorPrices({
  mgItemNumber,
  assortmentId,
  ...queryOptions
}: AssortmentCompetitorPricesProps) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<CompetitorMgItemPriceDTO[]>({
    method: 'GET',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.competitorPrices.assortment.assortmentId.mgItem.mgItemNumber.getFullLinkPath({
        assortmentId,
        mgItemNumber,
      }),
    }),
    token,
    queryKey: ['mg-item-assortment-competitor-prices', assortmentId, mgItemNumber],
    ...queryOptions,
  });
}
